import { makeStyles } from "@material-ui/styles";
import { CELL_HEIGHTS } from "@utils";

export default makeStyles(() => ({
  utilizationRow: {
    height: CELL_HEIGHTS.LARGE,
    pointerEvents: "auto",
  },
  utilizationMemberRow: {
    height: CELL_HEIGHTS.MEDIUM,
    pointerEvents: "auto",
  },
}));
